import type { MCQQuestion as MCQQuestionType } from '@/types';

interface Props {
  question: MCQQuestionType;
  selectedAnswer: string | null;
  onAnswer: (questionId: string, answer: string) => void;
  showResults: boolean;
}

export default function MCQQuestion({ question, selectedAnswer, onAnswer, showResults }: Props) {
  return (
    <div className="quiz-question mcq-question">
      <p className="question-text">{question.question}</p>
      <div className="mcq-options">
        {question.options.map((opt) => {
          const isSelected = selectedAnswer === opt.id;
          const isCorrect = opt.id === question.correctOptionId;
          let optionClass = 'mcq-option';
          if (showResults) {
            if (isCorrect) optionClass += ' correct';
            else if (isSelected && !isCorrect) optionClass += ' incorrect';
          } else if (isSelected) {
            optionClass += ' selected';
          }

          return (
            <button
              key={opt.id}
              className={optionClass}
              onClick={() => !showResults && onAnswer(question.id, opt.id)}
              disabled={showResults}
            >
              <span className="option-indicator">
                {showResults && isCorrect ? '\u2713' : showResults && isSelected && !isCorrect ? '\u2717' : opt.id.toUpperCase()}
              </span>
              <span className="option-text">{opt.text}</span>
            </button>
          );
        })}
      </div>
      {showResults && question.explanation && (
        <div className="question-explanation">
          <strong>Explanation:</strong> {question.explanation}
        </div>
      )}
    </div>
  );
}
